import React from "react";

import Checkbox from "@cayuse/shared-react.components.form.inputs.checkbox";
import PropTypes from "prop-types";

import RuleRowText from "containers/Rules/List/RulesRenderer/RuleRowText/RuleRowText";

const AdditionalReview = ({ rule, rollupEnabled, styles, dictionary, handleRollupChange, showRequieReview = false }) => (
	<div className={styles.spaceLeft}>
		<div className={styles.spaceBottom}>
			<RuleRowText column="action" rule={rule} />
		</div>

		{showRequieReview && <Checkbox
			label={
				dictionary.additionalReview || "Require Additional Review"
			}
			checked={rollupEnabled}
			disabled={!rule.isActionEditing}
			onChange={handleRollupChange}
		/>}
	</div>
);

AdditionalReview.propTypes = {
	rollupEnabled: PropTypes.bool,
	rule: PropTypes.object,
	styles: PropTypes.object,
	dictionary: PropTypes.object,
	handleRollupChange: PropTypes.func,
};

export default AdditionalReview;
